// Generic data table — same Column<T> interface as OMNI

import type { ReactNode } from "react";

interface Column<T> {
	key: string;
	header: string;
	render: (item: T) => ReactNode;
}

interface DataTableProps<T> {
	columns: Column<T>[];
	data: T[];
	rowKey: (item: T) => string | number;
}

export function DataTable<T>({ columns, data, rowKey }: DataTableProps<T>) {
	if (data.length === 0) {
		return (
			<div className="card" style={{ textAlign: "center", padding: "var(--space-8)" }}>
				<span style={{ color: "var(--color-ink-muted)" }}>No data</span>
			</div>
		);
	}

	return (
		<table className="data-table">
			<thead>
				<tr>
					{columns.map((col) => (
						<th key={col.key}>{col.header}</th>
					))}
				</tr>
			</thead>
			<tbody>
				{data.map((item) => (
					<tr key={rowKey(item)}>
						{columns.map((col) => (
							<td key={col.key}>{col.render(item)}</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);
}
